import { context } from '@wikia/ad-engine';

export function getAppnexusContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					position: 'middle',
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				position: 'atf',
			},
			top_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
				],
				position: 'atf',
			},
			...midBoxAdConfigs,
			incontent_boxad: {
				sizes: [
					[160, 600],
					[300, 600],
					[300, 250],
					[300, 1050],
				],
				position: 'hivi',
			},
			bottom_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				position: 'btf',
			},
			fandom_dt_galleries: {
				sizes: [[728, 90]],
				position: 'gallery',
			},
		},
		placements: {
			atf: '11977073',
			btf: '11977096',
			hivi: '11977016',
			gallery: '31721311',
			middle: '34428687',
			native: '25450069',
			other: '11969927',
		},
	};
}
